import { AbstractControl, ValidationErrors } from '@angular/forms';

export function rxCheckedValidator(control: AbstractControl): ValidationErrors | null {
  return control.value === true ? null : { required: true };
}
